import { ActionLink } from '@cian/ui-kit/link';
import { Theme } from '@cian/ui-kit/theme';
import { IconFunctionalInformation16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './NotFoundToast.css';

const NOT_FOUND_TOAST_TEXT = 'Сбросьте фильтры или измените область карты';

/**
 * Иконка и текст тоста. Иконку кладём в контент, а не в leftAdornment:
 * leftAdornment ui-kit центрирует по высоте, а по макету иконка прижата к верху текста
 */
export const NotFoundToastContent: React.FC = () => {
  return (
    <span className={styles['content']}>
      <Theme theme="dark" displayContents>
        <span className={styles['icon']}>
          <IconFunctionalInformation16 color="icon-inverted-default" />
        </span>
      </Theme>
      <span>{NOT_FOUND_TOAST_TEXT}</span>
    </span>
  );
};

interface INotFoundToastActionProps {
  onClick(): void;
}

export const NotFoundToastAction: React.FC<INotFoundToastActionProps> = ({ onClick }) => {
  return (
    <Theme theme="dark" displayContents>
      <span className={styles['action']}>
        <ActionLink fontSize="M" onClick={onClick}>
          Изменить фильтры
        </ActionLink>
      </span>
    </Theme>
  );
};
